import type { IFSItem } from 'bz-core-controls/hooks-form/controls/field-select';
import CacheStore from 'bz-utilities/modules/stores/cached-map-store';
import { computed } from 'mobx';
import { createTransformer } from 'mobx-utils';
import type { GeneralPractitionerResponse, PractitionerLocation } from '../../api.dtos';

class PractitionerStore extends CacheStore<GeneralPractitionerResponse> {
  ByLocation = createTransformer((locationId: number) => {
    let res = this.All.filter((x) => x.locationIds.includes(locationId));
    return res;
  });

  ActivePractitionersByLocation = createTransformer((locationId: number) => {
    return !locationId
      ? this.Current
      : this.Current.filter((x) => x.locationIds.includes(locationId));
  });

  ActivePractitionersByMultipleLocations = createTransformer((locationIds: number[]) => {
    if (!locationIds || locationIds.length === 0) {
      return [];
    }
    return this.Current.filter((x) => x.locationIds.some((id) => locationIds.includes(id)));
  });

  ByStatus = createTransformer((status: number) => {
    let res = this.All.filter((x) => x.status === status);
    return res;
  });

  ActivePractitionersByLocationForDropdown = createTransformer((locationId: number) => {
    return this.ActivePractitionersByLocation(locationId).map((x) => ({
      text: x.fullName,
      payload: x.id
    }));
  });

  ActivePractitionersByLocationForOnlineDropdown = createTransformer((locationId: number) => {
    return this.ActivePractitionersByLocation(locationId).map((x) => ({
      text: x.fullName,
      payload: x.onlineGuid
    }));
  });

  constructor() {
    super('practitioners');
    this.orderBy = 'orderId' as keyof GeneralPractitionerResponse;
  }

  public search(searchTerm: string = '', locationId: number): GeneralPractitionerResponse[] {
    if (!searchTerm) return this.ActivePractitionersByLocation(locationId);
    const lowerSearchTerm = searchTerm.toLowerCase();
    return this.ActivePractitionersByLocation(locationId).filter((practitioner) =>
      practitioner?.fullName?.toLowerCase().includes(lowerSearchTerm)
    );
  }

  @computed get Current() {
    return this.All.filter((x) => x.status === 1 || x.status === 2);
  }

  @computed
  get CurrentPractitionersForOnlineDropdown(): IFSItem[] {
    return this.Current.map((c) => ({ text: c.fullName, payload: c.onlineGuid }));
  }

  @computed get Licensed() {
    return this.All.filter((x) => x.status === 2); // licensed only
  }
}
export class PractitionerLocationStore extends CacheStore<PractitionerLocation> {
  constructor() {
    super('practitionerLocations');
  }
}

export default PractitionerStore;
